import styled from 'styled-components';

import { grey10, white } from '@zocdoc/branding/colors';

import {
    INPUT_BORDER_WIDTH,
    INPUT_HEIGHT,
    INPUT_X_AFFORDANCE_DESKTOP,
    INPUT_X_AFFORDANCE_MOBILE,
    NON_INPUT_X_AFFORDANCE_DESKTOP,
    NON_INPUT_X_AFFORDANCE_MOBILE,
} from '../picker-constants';

import { breakpoint } from '../grid';
import { Close } from '../icons';
import { FontFamily } from '../typography';

const Item = styled.div`
    color: ${p => p.theme.components.TakeoverInput.option.textColor};
    padding-left: ${NON_INPUT_X_AFFORDANCE_MOBILE}px;
    padding-right: ${NON_INPUT_X_AFFORDANCE_MOBILE}px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;

    ${breakpoint.small} {
        padding-left: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
        padding-right: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
    }
`;

export const Label = styled(Item)`
    font: 15px/20px ${FontFamily.SharpSansBold};
    letter-spacing: 0.2px;
    margin: 12px 0 6px;
`;

export const Option = styled(Item)`
    cursor: pointer;
    font: 15px/32px ${FontFamily.SharpSansMedium};

    &[data-selected="true"] {
        background-color: ${p => p.theme.components.TakeoverInput.option.bgColorHover};
        mark {
            color: ${p => p.theme.components.TakeoverInput.highlightText.textColorHover};
        }
    }

    mark {
        background-color: transparent;
        color: ${p => p.theme.components.TakeoverInput.highlightText.textColor};
    }
`;

export const Wrapper = styled.div`
    &[data-dropdown-active="true"] {
        z-index: 10;

        ${breakpoint('xsmall', { down: true })} {
            background-color: white;
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
        }
    }

    ${breakpoint.small} {
        position: relative;
    }
`;

export const FieldWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const Field = styled.div`
    position: relative;
    flex-grow: 1;
`;

export const FieldInput = styled.input`
    appearance: none;
    background: ${white};
    border: ${INPUT_BORDER_WIDTH}px solid ${white};
    border-radius: 0;
    color: ${p => p.theme.components.TakeoverInput.input.textColor};
    font: 15px ${FontFamily.SharpSansSemibold};
    height: ${INPUT_HEIGHT}px;
    padding: 0 ${INPUT_X_AFFORDANCE_MOBILE}px;
    width: 100%;

    &::placeholder {
        color: ${p => p.theme.components.TakeoverInput.placeholder.textColor};
    }

    &:focus::placeholder {
        color: ${p => p.theme.components.TakeoverInput.placeholder.textColorFocus};
    }

    ${breakpoint('xsmall', { down: true })} {
        ${Wrapper}[data-dropdown-active="true"] & {
            padding-right: 28px; // space for the clear button
        }
    }

    ${breakpoint.small} {
        padding: 0 ${INPUT_X_AFFORDANCE_DESKTOP}px;
    }
`;

export const ClearButton = styled(Close)`
    cursor: pointer;
    font-size: 10px;
    padding: 6px 16px;
    box-sizing: content-box;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    ${breakpoint.small} {
        display: none;
    }
`;

export const Separator = styled.div`
    [data-dropdown-active="true"] & {
        width: 1px;
        height: 20px;
        background-color: #e1e1e4;
    }

    ${breakpoint.small} {
        display: none;
    }
`;

export const CancelButton = styled.div`
    color: ${p => p.theme.components.TakeoverInput.input.textColor};
    cursor: pointer;
    font: 13px/1 ${FontFamily.SharpSansSemibold};
    padding: 16px;

    ${breakpoint.small} {
        display: none;
    }
`;

export const DropdownWrapper = styled.div`
    background-color: white;
    border-top: 1px solid ${grey10};
    border-bottom: 1px solid ${grey10};
    overflow-y: auto;
    padding: 16px 0;
    position: absolute;
    top: ${INPUT_HEIGHT}px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;

    ${breakpoint.small} {
        max-height: 300px;
        bottom: auto;
    }
`;
